// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /invite/list.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeInviteListBody,
  typeInviteListOutput200,
} from "../../sdk/invite/postInviteList";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildInviteListQueryKey(payload: typeInviteListBody): string[] {
  const queryKeySegments: string[] = [];

  return ["post:invite:inviteList", "svc:pool-api", ...queryKeySegments];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeInviteListOutput200,
    unknown,
    typeInviteListOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useInviteList(
  payload: typeInviteListBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildInviteListQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postInviteList(payload),
    ...resolvedOptions,
  });
}
